import { Validators } from '@angular/forms';

export class Validation {
    public rules = (): object => {
        return {
            cdPerfilTipo: ['', Validators.required],
            nmPerfilTipo: ['', Validators.required],
        };
    };
}
